import { PRE_INSCRIPTIONS_ROUTES as preInscriptionRoutes } from "~/api/routes";

export const state = () => ({
  pre_inscriptions: [],
  pagination: {},
  isRequesting: false,
  hasError: false,
});

export const getters = {
  allComptes: (state) => state.pre_inscriptions,
};

export const mutations = {
  PRE_INSCRIPTION_INIT(state) {
    state.hasError = false;
    state.pre_inscriptions = [];
  },
  IS_REQUESTING(state, isRequesting) {
    state.isRequesting = isRequesting;
  },
  PRE_INSCRIPTION_SUCCESS(state, pre_inscriptions) {
    state.pre_inscriptions = pre_inscriptions;
  },
  PRE_INSCRIPTION_PAGINATION(state, pagination) {
    delete pagination.data;
    state.pagination = pagination;
  },
  PRE_INSCRIPTION_ERROR(state) {
    state.pre_inscriptions = [];
    state.pagination = {};
    state.hasError = true;
  },
};

export const actions = {
  async getPreInscriptions({ commit }, params = {}) {
    const page = 1;
    params.page = params.page ? params.page : page;
    try {
      commit("PRE_INSCRIPTION_INIT");
      commit("IS_REQUESTING", true);
      const queryUrl = { ...preInscriptionRoutes.list };
      queryUrl.endPoint += "&page=" + params.page;
      this.$api
        .request(queryUrl, {}, params)
        .then((response) => {
          if (
            response.payload.current_page > 1 &&
            (!response.payload.data || response.payload.data.length === 0)
          ) {
            this.dispatch("pre_inscription/getPreInscriptions", {
              page: 1,
            });
          }
          commit("PRE_INSCRIPTION_SUCCESS", response.payload.data);
          commit("PRE_INSCRIPTION_PAGINATION", response.payload);
        })
        .catch((_) => {
          commit("PRE_INSCRIPTION_ERROR");
        })
        .finally(() => {
          commit("IS_REQUESTING", false);
        });
    } catch (e) {}
  },

  // async reducePoints({commit}, params) {
  //   return new Promise((resolve, reject) => {
  //     this.$api.request(preInscriptionRoutes.reducepoints, {},params).then(resp =>{

  //     vue.$toast.success(resp._response.message);
  //     commit('REDUCE_POINTS', params);
  //       resolve();
  //   });
  //   });
  // }
};
